import Cookies from 'js-cookie'
import { useSelector } from 'store/redux.store'

export const useExtensions = () => {
  const {
    user: { ucode }
  } = useSelector(state => state)

  const setActivationSource = (source: string) => {
    Cookies.set('audience_source', {
      ucode,
      source,
      channel: 'audience_page'
    })
  }

  return {
    setActivationSource
  }
}
